import Icon from '@mui/material/Icon';
import { styled } from '@mui/material/styles';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { useMemo } from 'react';
import FuseNavBadge from '../../FuseNavBadge';
import { FEATURED_COLOR } from '../../featured';

const NAV_ICON_BOX_CLASSES =
  'fuse-list-item-icon shrink-0 flex items-center justify-center vtwo:size-6.5 vtwo:mr-3';

const featuredIconStyle = {
  backgroundColor: FEATURED_COLOR,
};

const Root = styled(ListItem)(({ theme, ...props }) => ({
  height: 36,
  width: '100%',
  borderRadius: '6px',
  margin: '0 0 4px 0',
  paddingRight: 12,
  paddingLeft: props.itempadding > 80 ? 80 : props.itempadding,
  '&.active': {
    backgroundColor: `${theme.palette.secondary.main}!important`,
    color: `${theme.palette.secondary.contrastText}!important`,
    pointerEvents: 'none',
    transition: 'border-radius .15s cubic-bezier(0.4,0.0,0.2,1)',
    '& > .fuse-list-item-text-primary': {
      color: 'inherit',
    },
    '& > .fuse-list-item-icon': {
      color: 'inherit',
    },
  },
  '& > .fuse-list-item-icon': {
    marginRight: 12,
  },
  '& > .fuse-list-item-text': {},
  color: theme.palette.text.primary,
  textDecoration: 'none!important',
}));

function FuseNavVerticalLink(props) {
  const { item, nestedLevel, onItemClick } = props;

  const itempadding = nestedLevel > 0 ? 28 + nestedLevel * 16 : 12;

  return useMemo(() => {
    if (item.display === false) return null;

    return (
      <Root
        button
        component="a"
        href={item.url}
        target={item.target ? item.target : '_blank'}
        className="fuse-list-item"
        onClick={(ev) => onItemClick && onItemClick(item, ev)}
        role="button"
        itempadding={itempadding}
      >
        {(item.icon || item.img) && <NavLinkIcon item={item} />}

        <ListItemText
          className="fuse-list-item-text"
          primary={item.title}
          classes={{ primary: 'fuse-list-item-text-primary' }}
        />

        {item.badge && <FuseNavBadge badge={item.badge} />}
      </Root>
    );
  }, [item, itempadding, onItemClick]);
}

FuseNavVerticalLink.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string,
    icon: PropTypes.string,
    url: PropTypes.string,
    target: PropTypes.string,
  }),
};

function NavLinkIcon({ item }) {
  const featured = !!item.featured;

  return (
    <span
      className={clsx(NAV_ICON_BOX_CLASSES, featured && 'vtwo:rounded-md')}
      style={featured ? featuredIconStyle : undefined}
    >
      {item.img ? (
        <img className="vtwo:size-5" src={item.img} alt={item.title} />
      ) : (
        <Icon
          className={clsx('vtwo:text-[20px]!', item.iconClass || (featured ? 'text-white' : null))}
          color={featured ? undefined : 'action'}
        >
          {item.icon}
        </Icon>
      )}
    </span>
  );
}

const NavVerticalLink = FuseNavVerticalLink;

export default NavVerticalLink;
